import store from 'utils/store/withMiddleware'

function getQuestionValueFromState(questionKey: string) {
  const [questionId, answerId] = questionKey.split('-')
  const questions = store.getState().questions
  const questionIndex = questions.findIndex(question => question.id == questionId)

  if (questionIndex < 0) {
    throw `Question ID ${questionId} not found.`
  }

  const question = questions[questionIndex]
  let questionText = `${question.question}`
  questionText += question.questionSubtext ? ` ${question.questionSubtext.join(' ')}` : ''
  const answer = question.possibleAnswers[answerId]

  if (!answer) {
    throw `Answer ID ${answerId} not found.`
  }

  return `${questionId}|${questionText}|${answerId}|${answer}`
}

export { getQuestionValueFromState }
